var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7998 9.66895C21.7998 7.54721 20.957 5.51238 19.4567 4.01209C17.9564 2.5118 15.9215 1.66895 13.7998 1.66895C11.6781 1.66895 9.64324 2.5118 8.14295 4.01209C6.64266 5.51238 5.7998 7.54721 5.7998 9.66895C5.7998 19.0023 1.7998 21.6689 1.7998 21.6689H25.7998C25.7998 21.6689 21.7998 19.0023 21.7998 9.66895Z",
    fill: "#F2F2F3",
    stroke: "#F2F2F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1055 27.002C15.8711 27.4061 15.5346 27.7415 15.1298 27.9747C14.725 28.2078 14.266 28.3306 13.7989 28.3306C13.3317 28.3306 12.8727 28.2078 12.4679 27.9747C12.0631 27.7415 11.7266 27.4061 11.4922 27.002",
    stroke: "#F2F2F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert_icon.a5189ab377dc03d83a58c3514d3158f5.svg";
export { ForwardRef as ReactComponent };